import { useEffect, useState } from "react";
import Loading from "../Loading";


function Messages(){

    const [ loading, setLoading ] = useState();
    const [ messages, setMessages ] = useState();
    const [error, setError ] = useState();
    const time = new Date().getTime();
    const defined = (v) => v !== undefined && v !== null && v !== "";

     useEffect(() => {    
    
            async function fetchData() {
                setLoading(true)
                try {
                    const dbResponse = await fetch('/api/system/banner/getmessages', {
                            method: 'GET'
                        }
                    );
                    const ans = await dbResponse.json();
                    setMessages(ans)
                 if (!ans.status.success) throw new Error('Failed to fetch');
                     
                } catch (error) {
                    console.error("Error fetching banner:", error);
                }
                setLoading(false);
            } fetchData();
    
    
        }, []);


        if(loading){
            return(<>
            <Loading />
         </>)
        }

        //alert(messages)

        if(!defined(messages)){
            //setError("Failed to Load Data")
            return(
                <>error</>
            )
        }

    const msgs = messages.responseData.maintenance.cdlis || [];

    return(<div> 
    
        <div className='Index'>
            <div id='table' style={{width: '70%', padding:'0px 10px 10px'}}>
                 <div id="banner-search">
                    <h4> Maintenance</h4>
                 </div>
                <thead>
                <tr>
                    <th>
                        <div className="form-text mt-2 text-muted">
                            Message
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                {msgs.map((message) => (
                    <tr>
                    <td><hr />{message}</td>
                    </tr>
                ))}
                </tbody>
            </div>
        </div>
       
    </div>)
}

/*
                   <tr>
                {msgs.map((v) => (
                    <tr>
                    <td>{v.from}</td>
                    <td>{v.to}</td>
                    <td>{v.message}</td>
                    </tr>
                ))}
                </tr>
*/

export default Messages